import constants from "../constants";

const {
  UPDATE_ALL_SERVICES_STORE,
  REMOVE_SERVICES_STORE,
  UPDATE_SERVICE_EVENTS_STORE,
  REMOVE_SERVICE_EVENT_STORE,
  UPDATE_SERVICE_EVENT_STORE,
  UPDATE_ALL_SERVICES_CATEGORIES_STORE,
  UPDATE_SERVICE_CATEGORY_STORE,
  REMOVE_SERVICE_CATEGORIES_STORE,
  UPDATE_SERVICE_STORE,
} = constants;

const initialState = {
  services: {},
  servicesCategories: {},
  serviceEvents: {},
};

export default (state = initialState, action) => {
  if (!action) return state;

  const { type } = action;

  switch (type) {
    // SERVICES
    case UPDATE_ALL_SERVICES_STORE:
      return { ...state, services: { ...action.data } };

    case UPDATE_SERVICE_STORE: {
      const serviceData = action?.serviceData;
      const uid = serviceData?.uid;

      return {
        ...state,
        services: {
          ...state.services,
          [uid]: { ...serviceData },
        },
      };
    }

    case REMOVE_SERVICES_STORE: {
      const uidsToRemove = action?.removedIds || [];

      const updatedServices = { ...state.services };

      uidsToRemove.forEach((uid) => {
        if (uid && updatedServices[uid]) {
          delete updatedServices[uid];
        }
      });

      return {
        ...state,
        services: updatedServices,
      };
    }

    // SERVICE CATEGORIES
    case UPDATE_ALL_SERVICES_CATEGORIES_STORE:
      return { ...state, servicesCategories: { ...(action.data || {}) } };

    case UPDATE_SERVICE_CATEGORY_STORE: {
      const serviceCategoryData = action?.serviceCategoryData;
      const uid = serviceCategoryData?.uid;

      return {
        ...state,
        servicesCategories: {
          ...state.servicesCategories,
          [uid]: { ...serviceCategoryData },
        },
      };
    }

    case REMOVE_SERVICE_CATEGORIES_STORE: {
      const uidsToRemove = action?.removedIds || [];

      const updatedServicesCategories = { ...state.servicesCategories };

      uidsToRemove.forEach((uid) => {
        if (uid === null) delete updatedServicesCategories[uid];
        if (uid && updatedServicesCategories[uid]) {
          delete updatedServicesCategories[uid];
        }
      });

      return {
        ...state,
        servicesCategories: updatedServicesCategories,
      };
    }

    // SERVICE EVENTS
    case UPDATE_SERVICE_EVENTS_STORE: {
      return {
        ...state,
        serviceEvents: { ...(action.data || {}) },
      };
    }

    case UPDATE_SERVICE_EVENT_STORE: {
      const { event } = action.data || {};
      const { serviceId, id: eventId, clientReservationId } = event || {};

      if (!serviceId || !eventId || !clientReservationId) return state;

      return {
        ...state,
        serviceEvents: {
          ...state.serviceEvents,
          [serviceId]: {
            ...state.serviceEvents[serviceId],
            [clientReservationId]: {
              ...(state.serviceEvents[serviceId]?.[clientReservationId] || {}),
              [eventId]: event,
            },
          },
        },
      };
    }

    case REMOVE_SERVICE_EVENT_STORE: {
      const { serviceId, eventId, clientReservationId } = action.data || {};

      if (!serviceId || !eventId || !clientReservationId || !state.serviceEvents[serviceId]) {
        return state;
      }

      const updatedEventsByReservation = { ...state.serviceEvents[serviceId] };

      if (!updatedEventsByReservation[clientReservationId]) return state;

      const updatedReservationEvents = { ...updatedEventsByReservation[clientReservationId] };
      delete updatedReservationEvents[eventId];

      if (Object.keys(updatedReservationEvents).length === 0) {
        delete updatedEventsByReservation[clientReservationId];
      } else {
        updatedEventsByReservation[clientReservationId] = updatedReservationEvents;
      }

      return {
        ...state,
        serviceEvents: {
          ...state.serviceEvents,
          [serviceId]: updatedEventsByReservation,
        },
      };
    }
    default:
      return state;
  }
};
